import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    validateAll(event) {
        // Find all validation controllers in the form
        const form = this.element;
        
        // Trigger validation on all fields with validation controllers
        const percentageInput = form.querySelector('[data-controller*="percentage-validation"]');
        const emailInput = form.querySelector('[data-controller*="email-validation"]');
        
        // Dispatch blur events to trigger validation
        if (percentageInput) {
            percentageInput.dispatchEvent(new Event('blur', { bubbles: true }));
        }
        
        if (emailInput) {
            emailInput.dispatchEvent(new Event('blur', { bubbles: true }));
        }
        
        // Check if any field has errors
        const hasErrors = form.querySelectorAll('.is-invalid').length > 0;
        
        if (hasErrors) {
            event.preventDefault();
            event.stopPropagation();
            
            // Focus on the first invalid field
            const firstInvalid = form.querySelector('.is-invalid');
            if (firstInvalid) {
                firstInvalid.focus();
            }
        }
    }
}